import React, { useContext } from "react";
import NavPanel from "../Common/Nav/NavPanel";
import NavItemButtonWithIcon from "../Common/Nav/NavItem/NavItemButtonWithIcon";
import { IsMobileContext } from "../isMobileContext";
import { sportsIconMap, sportsSlugIdMap } from "../Common/constants";
import { SportSelectMobile } from "../Common/Dropdowns";

const SportFilter = ({
  filterOptions,
  name,
  currentFilter,
  onFilterOnSport
}) => {
  const ctx = useContext(IsMobileContext);

  if (filterOptions.length < 3) {
    return null;
  }

  if(ctx.isMobile){
    return (
      <div className="mobile-filters-container results-filters-container">
        <SportSelectMobile onClick={onFilterOnSport}  activeFilter={currentFilter}  filters={filterOptions} />
      </div>
    )
  }

  return (
    <NavPanel
      name={name}
      items={filterOptions}
      collapsible
      collapsedByDefault
      renderItem={makeFunctionToRenderSportFilterButton(
        currentFilter,
        onFilterOnSport
      )}
    />
  );
};

const getIconClass = sport => {
  if (sport.slug === "all-sports") {
    return null;
  }
  return `z-icon ${sportsIconMap[sportsSlugIdMap[sport.slug]]}`;
};

const makeFunctionToRenderSportFilterButton = (currentFilter, onClick) =>
  // eslint-disable-next-line react/display-name
  sport => (
    <NavItemButtonWithIcon
      key={sport.slug}
      title={sport.name}
      onClick={() => onClick(sport)}
      iconClass={getIconClass(sport)}
      active={currentFilter.slug === sport.slug}
    />
  );

export default SportFilter;
